module.exports = __webpack_public_path__ + "img/image4.c1533711.png";